// import React, {useState,useEffect} from 'react';
// import './Sim.css';
// import {DragDropContext, Droppable, Draggable} from "react-beautiful-dnd";
// import _ from "lodash";
// import { useMutation } from "@apollo/client";
// import {addAircraftTemp} from '../../../Queries/AircraftQuery/AirCraftQuery'
// function AircraftPhases(props) {
//   const [state, setState] = useState()
//   const [progress,setProgress] = useState([]) 
//   const [search, setsearch] = useState('')
//   const [addAircraft, { data }] = useMutation(addAircraftTemp)
//   useEffect(() => {
//       setState({
//         "todo": {
//             title: "Technical Competency",
//             items: props?.data?.aatmsv4_atclist
//           },
//           "in-progress": {
//             title: "Selected Technical Competency",
//             items: progress.length ? progress : []
//           }
//       })
//   }, [props?.data])
//   const handleDragEnd = ({destination, source}) => {
//     if (!destination) {
//       return
//     } 
//     if(destination.droppableId === "todo" && destination.droppableId === source.droppableId){
//       let srcItem1 = state[source.droppableId].items[source.index];
//       let destItem1 = state[destination.droppableId].items[destination.index]; 
//       let copyItems = [...state[source.droppableId].items]
//       copyItems.splice(source.index, 1 , destItem1)
//       copyItems.splice(destination.index, 1 , srcItem1)
//       state[source.droppableId].items = copyItems;
//       setState({...state})
//        return 
//     }
//     if (destination.droppableId === "in-progress" && destination.droppableId === source.droppableId) {
//       let srcItem = state[source.droppableId].items[source.index];
//       let destItem = state[destination.droppableId].items[destination.index]; 
//       state[source.droppableId].items[source.index] = destItem
//       state[destination.droppableId].items[destination.index] = srcItem
//       progress[source.index] = destItem;
//       progress[destination.index] = srcItem;
//       setProgress([...progress])
//       setState({...state})
//       return
//     }
//     // Creating a copy of item before removing it from state
//     const itemCopy = {...state[source.droppableId].items[source.index]}
//     var flag = false;
//     state[destination.droppableId].items.map( v => {  if(v?.atcid ===  itemCopy.atcid) flag = true})
//     if(flag){
//       return
//     }
//       let sourceItems = [...state[source.droppableId].items]
//       let destinationItems = [...state[destination.droppableId].items]

//       destinationItems.splice(destination.index, 0 , itemCopy)
//       sourceItems.splice(source.index,1)

//       state[source.droppableId].items = sourceItems;
//       state[destination.droppableId].items = destinationItems;
//     setState({...state})
//     setProgress([...state[destination.droppableId].items])
//     addAircraft({
//       variables: {aircraftFormName: props.name,shortName: itemCopy.atcshortname,sequence:source.index + 1 ,atcid: itemCopy.atcid,atcname: itemCopy.atcname ,ata:itemCopy.ata,phase:props.phase }
//     }) }

//   return (
//     <div>
//       <input className="input" placeholder="Search..." type="text" onChange={(e) => setsearch(e.target.value)}/>
//     <div className="App" >
//       <DragDropContext onDragEnd={handleDragEnd}> 
//         {_?.map(state, (data, key) => {
//           return(
//             <div key={key} className={"column"}>
//               <span className="title">{data.title}</span>
//               <Droppable droppableId={key}>
//                 {(provided) => {
//                   return(
//                     <div
//                       ref={provided.innerRef}
//                       {...provided.droppableProps}
//                       className={"droppable-col"} >
//                       {data?.items?.map((el, index) => {
//                         if (el?.atcname?.toLowerCase().includes(search.toLowerCase())) {
//                         return(
//                           <Draggable key={el?.atcid} index={index} draggableId={el?.atcid + data.title}>
//                             {(provided, snapshot) => {
//                               return(
//                                 <div
//                                   className={`item ${snapshot.isDragging && "dragging"}`}
//                                   ref={provided.innerRef}
//                                   {...provided.draggableProps}
//                                   {...provided.dragHandleProps}>
//                                  {index + 1}: {el?.atcname}
//                                 </div>
//                               ) }}
//                           </Draggable> ) }})}
//                       {provided.placeholder}
//                     </div>  ) }}
//               </Droppable>
//             </div> ) })} 
//       </DragDropContext>
//     </div>
//     <button className="cancel-button" onClick={() => {
//       props.togglee(false)
//     }}>Back</button>
//     </div>
//   );
// }

// export default AircraftPhases;


import React, { useState, useEffect } from 'react';
import './Sim.css';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import _ from "lodash";
import { useMutation } from "@apollo/client";
import { addAircraftTemp } from '../../../Queries/AircraftQuery/AirCraftQuery'


function AircraftPhases(props) {
  const [state, setState] = useState()
  const [todos, setTodos] = useState([])
  const [progress, setProgress] = useState([])
  const [addAircraft, { data }] = useMutation(addAircraftTemp)
  useEffect(() => {
    setState({
      "todo": {
        title: "Technical Competency",
        items: props?.data?.aatmsv4_atclist
      },
      "in-progress": {
        title: "Selected Technical Competency",
        items: progress.length ? progress : []
      }
    })
    setTodos(props?.data?.aatmsv4_atclist)
  }, [props?.data])

  const handleDragEnd = ({ destination, source }) => {
    if (!destination) {
      return
    }

    if (destination.droppableId === "todo" && destination.droppableId === source.droppableId) {
      let srcItem1 = state[source.droppableId].items[source.index];
      let destItem1 = state[destination.droppableId].items[destination.index];
      let copyItems = [...state[source.droppableId].items]
      copyItems.splice(source.index, 1, destItem1)
      copyItems.splice(destination.index, 1, srcItem1)
      state[source.droppableId].items = copyItems;
      setState({ ...state })
      return
    }

    if (destination.droppableId === "in-progress" && destination.droppableId === source.droppableId) {
      let srcItem = state[source.droppableId].items[source.index];
      let destItem = state[destination.droppableId].items[destination.index];
      state[source.droppableId].items[source.index] = destItem
      state[destination.droppableId].items[destination.index] = srcItem
      progress[source.index] = destItem;
      progress[destination.index] = srcItem;
      setProgress([...progress])
      setState({ ...state })
      return
    }

    // Creating a copy of item before removing it from state
    const itemCopy = { ...state[source.droppableId].items[source.index] }
    var flag = false;
    state[destination.droppableId].items.map(v => { if (v?.atcid === itemCopy.atcid) flag = true })

    if (flag) {
      return
    }

    let sourceItems = [...state[source.droppableId].items]
    let destinationItems = [...state[destination.droppableId].items]

    destinationItems.splice(destination.index, 0, itemCopy)
    sourceItems.splice(source.index, 1)
    let copyTodos = [...todos]
    copyTodos.splice(source.index, 1)

    state[source.droppableId].items = sourceItems;
    state[destination.droppableId].items = destinationItems;
    setState({ ...state })
    setProgress([...state[destination.droppableId].items])
    setTodos([...copyTodos])
    addAircraft({
      variables: { aircraftFormName: props.name, shortName: itemCopy.atcshortname, sequence: source.index + 1, atcid: itemCopy.atcid, atcname: itemCopy.atcname, ata: itemCopy.ata, phase: props.phase }
    })
  }



const handleSearch = (e) => {
  let todoItems = [...state.todo.items]
  let newArr = todos.filter(v => v.atcname.slice(0, e.target.value.length).toLowerCase() === e.target.value.toLowerCase() && v)
  if (newArr.length === 0) newArr = todos
  if (e.target.value.length === 0) newArr = todos
  state.todo.items = newArr;
  setState({ ...state })
}


return (
  <div>
    <input className="input" placeholder="Search..." type="text" onChange={handleSearch} />
    <div className="App" >
      <DragDropContext onDragEnd={handleDragEnd}>
        {_?.map(state, (data, key) => {
          return (
            <div key={key} className={"column"}>
              <span className="title">{data.title}</span>
              <Droppable droppableId={key}>
                {(provided, snapshot) => {
                  return (
                    <div
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                      className={"droppable-col"}
                    >
                      {data?.items?.map((el, index) => {
                        return (
                          <Draggable key={el?.atcid} index={index} draggableId={el?.atcid + data.title}>
                            {(provided, snapshot) => {
                              return (
                                <div
                                  className={`item ${snapshot.isDragging && "dragging"}`}
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                >
                                  {index + 1}: {el?.atcname}
                                </div>
                              )
                            }}
                          </Draggable>
                        )
                      })}
                      {provided.placeholder}
                    </div>
                  )
                }}
              </Droppable>
            </div>
          )
        })}
      </DragDropContext>
    </div>
    <button className="cancel-button" onClick={() => {
      props.togglee(false)
    }}>Done</button>
  </div>
)
}

export default AircraftPhases;